import React, { useCallback, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import NuevosDesarrollosModal from "./NuevosDesarrollosModal";

const ResponsiveHeader = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [isBoletinesOpen, setIsBoletinesOpen] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();

  const navLinks = [
    { path: "/", label: "Inicio", icon: "fa-home" },
    { path: "/servicios", label: "Servicios", icon: "fa-concierge-bell" },
    { path: "/productos", label: "Productos", icon: "fa-boxes-stacked" },
    { path: "/cedis", label: "Ubicaciones", icon: "fa-location-dot" },
    { path: "/contacto", label: "Contacto", icon: "fa-envelope" },
  ];

  // Submenú de Nosotros
  const nosotrosSubmenu = [
    { path: "/historia", label: "Historia", icon: "fa-clock-rotate-left" },
    { path: "/marca", label: "Nuestra Marca", icon: "fa-award" },
    { path: "/mision", label: "Misión, Visión y Valores", icon: "fa-bullseye" },
  ];

  // Tips de Expertos comentado
  // { path: "/ExpertsTips", label: "Tips de Expertos", icon: "fa-lightbulb" },

  const isActive = (path) => {
    if (path === "/") {
      return location.pathname === "/";
    }
    return location.pathname.toLowerCase() === path.toLowerCase();
  };

  const isNosotrosActive = () => {
    return nosotrosSubmenu.some(
      (item) => location.pathname.toLowerCase() === item.path.toLowerCase()
    );
  };

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const closeMenu = () => {
    setIsMenuOpen(false);
    setIsDropdownOpen(false);
  };

  const handleLogoClick = (e) => {
    closeMenu();
    // Si ya estamos en la página principal, activar la tab de Descripción
    if (location.pathname === "/") {
      e.preventDefault();
      // Activar la tab de Descripción usando Bootstrap
      const descTab = document.querySelector('a[href="#nav-descripcion"]');
      if (descTab) {
        descTab.click();
      }
      // Scroll al inicio
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
    // Si no estamos en "/", el Link navegará normalmente
  };

  const openBoletines = () => {
    closeMenu();
    setIsBoletinesOpen(true);
  };

  const closeBoletines = useCallback(() => setIsBoletinesOpen(false), []);

  const toggleDropdown = () => {
    setIsDropdownOpen(!isDropdownOpen);
  };

  return (
    <header className="responsive-header">
      <div className="header-container">
        {/* Logo */}
        <Link to="/" className="header-logo" onClick={handleLogoClick}>
          <img
            src={window.location.origin + "/GROB_logo.png"}
            alt="GROB Logo"
          />
        </Link>

        {/* Navegación Desktop */}
        <nav className="desktop-nav">
          {navLinks.slice(0, 3).map((link) => (
            <Link
              key={link.path}
              to={link.path}
              className={`nav-link-item ${isActive(link.path) ? "active" : ""}`}
            >
              {link.label}
            </Link>
          ))}

          {/* Ubicaciones */}
          <Link
            to="/cedis"
            className={`nav-link-item ${isActive("/cedis") ? "active" : ""}`}
          >
            Ubicaciones
          </Link>

          {/* Dropdown Nosotros */}
          <div
            className="nav-dropdown"
            onMouseEnter={() => setIsDropdownOpen(true)}
            onMouseLeave={() => setIsDropdownOpen(false)}
          >
            <button
              className={`nav-link-item nav-dropdown-trigger ${isNosotrosActive() ? "active" : ""}`}
            >
              Nosotros
              <i className={`fa-solid fa-chevron-down dropdown-arrow ${isDropdownOpen ? "open" : ""}`}></i>
            </button>
            <div className={`nav-dropdown-menu ${isDropdownOpen ? "open" : ""}`}>
              {nosotrosSubmenu.map((item) => (
                <Link
                  key={item.path}
                  to={item.path}
                  className={`nav-dropdown-item ${isActive(item.path) ? "active" : ""}`}
                >
                  {item.label}
                </Link>
              ))}
            </div>
          </div>

          {/* Contacto */}
          <Link
            to="/contacto"
            className={`nav-link-item ${isActive("/contacto") ? "active" : ""}`}
          >
            Contacto
          </Link>
        </nav>

        <div className="header-actions">
          {/* Nuevos Desarrollos (boletines PDF mensuales) */}
          <button
            type="button"
            className="nd-header-btn"
            onClick={openBoletines}
            aria-haspopup="dialog"
          >
            <span>Nuevos</span> <span>Desarrollos</span>
          </button>

          {/* Botón Hamburguesa para Móvil */}
          <button
            className={`hamburger-btn ${isMenuOpen ? "open" : ""}`}
            onClick={toggleMenu}
            aria-label="Abrir menú de navegación"
            aria-expanded={isMenuOpen}
          >
            <span className="hamburger-line"></span>
            <span className="hamburger-line"></span>
            <span className="hamburger-line"></span>
          </button>
        </div>
      </div>

      {/* Navegación Móvil */}
      <nav className={`mobile-nav ${isMenuOpen ? "open" : ""}`}>
        <div className="mobile-nav-header">
          <img
            src={window.location.origin + "/GROB_logo.png"}
            alt="GROB Logo"
            className="mobile-nav-logo"
          />
        </div>

        {/* Enlaces principales móvil */}
        {navLinks.slice(0, 3).map((link) => (
          <Link
            key={link.path}
            to={link.path}
            className={`mobile-nav-link ${isActive(link.path) ? "active" : ""}`}
            onClick={closeMenu}
          >
            <i className={`fa-solid ${link.icon}`}></i>
            {link.label}
          </Link>
        ))}

        {/* Ubicaciones móvil */}
        <Link
          to="/cedis"
          className={`mobile-nav-link ${isActive("/cedis") ? "active" : ""}`}
          onClick={closeMenu}
        >
          <i className="fa-solid fa-location-dot"></i>
          Ubicaciones
        </Link>

        {/* Dropdown Nosotros en móvil */}
        <button
          className={`mobile-nav-link mobile-dropdown-trigger ${isNosotrosActive() ? "active" : ""}`}
          onClick={toggleDropdown}
        >
          <i className="fa-solid fa-users"></i>
          Nosotros
          <i className={`fa-solid fa-chevron-down mobile-dropdown-arrow ${isDropdownOpen ? "open" : ""}`}></i>
        </button>
        <div className={`mobile-dropdown-menu ${isDropdownOpen ? "open" : ""}`}>
          {nosotrosSubmenu.map((item) => (
            <Link
              key={item.path}
              to={item.path}
              className={`mobile-dropdown-item ${isActive(item.path) ? "active" : ""}`}
              onClick={closeMenu}
            >
              {item.label}
            </Link>
          ))}
        </div>

        {/* Contacto móvil */}
        <Link
          to="/contacto"
          className={`mobile-nav-link ${isActive("/contacto") ? "active" : ""}`}
          onClick={closeMenu}
        >
          <i className="fa-solid fa-envelope"></i>
          Contacto
        </Link>
      </nav>

      {/* Backdrop overlay */}
      {isMenuOpen && (
        <div className="menu-backdrop" onClick={closeMenu}></div>
      )}

      <NuevosDesarrollosModal isOpen={isBoletinesOpen} onClose={closeBoletines} />
    </header>
  );
};

export default ResponsiveHeader;
